module.exports = __webpack_public_path__ + "img/fav_sync.864c5e05.jpg";